module.exports = __webpack_public_path__ + "img/home-banner.8e10d9fa.webp";